import { Select, Tooltip } from "antd";
import { varIs } from "common/var";
import { Button, Popconfirm } from "components/common";
import { useEffect, useState } from "react";

const { Option } = Select;

export default function ProductSpackSection(props) {
  const [isUpdating, setIsUpdating] = useState(false);
  // {spack_dimension: product|undefined}
  const [spackDetails, setSpackDetails] = useState({});

  const onSelect = (spackDimensionId, product) => {
    let spackDetails0 = { ...spackDetails };
    spackDetails0[spackDimensionId] = product;
    setSpackDetails(spackDetails0);
  };

  useEffect(() => {
    if (props.product && props.product.is_spack == 1) {
      let spackDetails0 = {};
      props.product.product_spack_details.forEach((el) => {
        if (el.spack_detail_products.length == 1) {
          spackDetails0[el.spack_dimension_id] =
            el.spack_detail_products[0].product;
        } else {
          spackDetails0[el.spack_dimension_id] = undefined;
        }
      });
      setSpackDetails(spackDetails0);
    }
  }, [props.product]);

  useEffect(() => {
    if (props.product && props.product.is_spack == 1) {
      let spackFilled0 = "";
      let containedProducts0 = [];
      Object.keys(spackDetails).forEach((k) => {
        if (!spackDetails[k]) {
          spackFilled0 = "Please complete your pack.";
        } else {
          containedProducts0.push({
            product_id: spackDetails[k]["id"],
            product: spackDetails[k],
            quantity: 1,
          });
        }
      });
      if (containedProducts0.length == 0) {
        spackFilled0 = "Please complete your pack.";
      }

      console.log(spackFilled0);
      console.log(containedProducts0);
      
      props.setSpackFilled(spackFilled0)
      props.setContainedProducts(containedProducts0)
    }
  }, [spackDetails]);

  const handleUpdate = () => {
    setIsUpdating(true);
  };

  return props.product?.is_spack == 1 ? (
    <>
      <hr
        style={{
          border: "none",
          height: "2px",
          backgroundColor: "#ccc",
          margin: "0 0 8px 0",
        }}
      />

      <h3 className="spack-detail-title">
        Your pack includes the below products:
      </h3>
      <div className="row">
        {props.product.product_spack_details.map((el) => (
          <div
            key={el.id}
            className="col-xs-12 col-sm-6 col-md-6 col-lg-6 spack-detail-box"
          >
            <div className="spack-dimension-name">
              {varIs(
                "productSpackDetail.showSelected",
                el.show_selected,
                "yes"
              ) ? (
                <>
                  {el.spack_dimension.name}:&nbsp;
                  {spackDetails[el.spack_dimension_id] && (
                    <strong>
                      {spackDetails[el.spack_dimension_id]["title"]}
                    </strong>
                  )}
                </>
              ) : (
                " "
              )}
            </div>
            <div className="spack-product-list">
              {el.spack_detail_products.length > 1 ? (
                <Select
                  className="spack-detail-products-select"
                  dropdownClassName="spack-detail-products-dropdown"
                  onSelect={(_, record) =>
                    onSelect(record.dimensionid, record.product)
                  }
                >
                  {el.spack_detail_products.map((el2) => (
                    <Option
                      key={el2.id}
                      dimensionid={el.spack_dimension_id}
                      product={el2.product}
                    >
                      <Tooltip
                        title={el2.product.title}
                        overlayClassName="contained-product-tooltip"
                      >
                        <div className="spack-product-card">
                          <div className="product-image">
                            <img src={el2.image} />
                          </div>
                          <div className="spack-contained-product-title">
                            {el2.product.title}
                          </div>
                        </div>
                      </Tooltip>
                    </Option>
                  ))}
                </Select>
              ) : (
                ""
              )}
              {el.spack_detail_products.length === 1 ? (
                <div className="spack-detail-products-select">
                  {el.spack_detail_products.map((el2) => (
                    <div className="">
                      <Tooltip
                        title={el2.product.title}
                        overlayClassName="contained-product-tooltip"
                      >
                        <div className="spack-product-card">
                          <div className="product-image">
                            <img src={el2.image} />
                          </div>
                          <div className="spack-contained-product-title">
                            {el2.product.title}
                          </div>
                        </div>
                      </Tooltip>
                    </div>
                  ))}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
      </div>

      <hr
        style={{
          border: "none",
          height: "2px",
          backgroundColor: "#ccc",
          margin: "0 0 0 0",
        }}
      />
    </>
  ) : (
    ""
  );
}
